"use strict";

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grab = void 0;

var GrabLinks_1 = require("./GrabLinks");

var Grab = /*#__PURE__*/function () {
  function Grab() {
    _classCallCheck(this, Grab);

    this.distance = 100;
    this.links = new GrabLinks_1.GrabLinks();
  }

  _createClass(Grab, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = data.distance;
      }

      this.links.load((_b = (_a = data.links) !== null && _a !== void 0 ? _a : data.lineLinked) !== null && _b !== void 0 ? _b : data.line_linked);
    }
  }, {
    key: "line_linked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "lineLinked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }]);

  return Grab;
}();

exports.Grab = Grab;